const data = {
  bookmark: true
};

export { data };
